import { Button, styled } from "@mui/material";

const CreateButton = styled(Button)(({ theme }) => ({
    float: 'inline-end',
    marginBottom: '1rem'
}));

export default CreateButton;